import { useEffect, useState } from "react";
import { motion, useScroll, useSpring } from "framer-motion";

/**
 * Slim scroll-progress bar pinned to the very top of the viewport.
 */
export default function ScrollProgress() {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.4 });

    return (
        <motion.div
            aria-hidden
            className="fixed top-0 left-0 right-0 h-[2px] bg-brand origin-left z-[9997]"
            style={{ scaleX }}
        />
    );
}
